import { classNames } from "@circle-react/helpers/twMergeWithCN";

import { legacyClassNames } from "@/react/helpers/cssAnchorHelpers";

export interface ImagePreviewProps {
  alt?: string;
  src?: string;
  value?: string;
}

export const ImagePreview = (props: ImagePreviewProps = {}) => {
  const { src, alt, value } = props;
  if (!value || !src) return <>{}</>;
  return (
    <img
      loading="lazy"
      className={classNames(
        legacyClassNames("quickpost__thumbnail"),
        "mb-4 rounded",
      )}
      src={src}
      alt={alt}
    />
  );
};

export type ImagePreviewFunc = typeof ImagePreview;
